import { ExternalRequests } from './../models/ExternalRequests';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})

export class ExternalRequestsService {

  API_URI = 'https://api.atrr.org.ar/api'

  constructor(private http: HttpClient) { }

  saveForm(externalRequests: ExternalRequests) {
    return this.http.post(`${this.API_URI}/external_requests`, externalRequests);
  }
}
